module.exports = __webpack_public_path__ + "img/gigwidog1.6c9e97ce.jpg";